import { type ReactNode } from 'react';
import type { AuthUser } from '@/types/auth';
import { useSelfProfile } from '../hooks/use-self-profile';
import { PersonalSection } from './personal-section';
import { ContactSection } from './contact-section';
import { IgHandlesSection } from './ig-handles-section';
import { PhraseSection } from './phrase-section';
import { ColorSection } from './color-section';
import { ActionBar } from './action-bar';
import type { ProfileUpdate } from '../types';

function initialFrom(user: AuthUser): ProfileUpdate {
  return {
    phone: user.phone ?? '',
    country: user.country ?? '',
    city: user.city ?? '',
    member_color: user.member_color ?? '',
  };
}

export function ProfileForm({ user }: { user: AuthUser }): ReactNode {
  const f = useSelfProfile(initialFrom(user));
  return (
    <div className="space-y-2xl">
      <PersonalSection
        firstName={user.first_name ?? ''}
        lastName={user.last_name ?? ''}
        email={user.email}
        birthdate={user.birthdate ?? ''}
      />
      <ContactSection values={f.values} setField={f.setField} />
      <IgHandlesSection user={user} />
      <PhraseSection initial={user.personal_phrase ?? ''} />
      <ColorSection values={f.values} setField={f.setField} />
      <ActionBar
        dirty={f.dirty}
        saving={f.saving}
        saved={f.saved}
        error={f.error}
        onSubmit={f.submit}
        onReset={f.reset}
      />
    </div>
  );
}
